import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getLayout: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide-picker/layout`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

// Returns the resolved PickerLayout, or null when the server has no arrangement
// for this user's segment (204 / empty body).
const getLayout = async ({ segmentOverride } = {}) => {
  const params = segmentOverride ? { segmentOverride } : {}
  const res = await resource.getLayout(params)
  return (res && res.body && res.body.layout) || null
}

export default { initResource, getLayout }
